// this component is purposely triggering a crash to test sentry and our error boundary
const CrashTestPage = () => {
  // @ts-expect-error TS type limitation
  return triggererror;
};

export default CrashTestPage;
